export const text = '#002839';
export const hover = '#002839';
export const whites = '#F5F5F5';
export const body = '#002839';
export const background = '#6EAFC4';
export const ease = 'cubic-bezier(0.4, 0, 0, 1)';
export const title = `'Suisse Intl', Arial, Helvetica, freesans, sans-serif`